import { postAddProductToCart, getGetVariants } from '@_api/productdetail';
import { getCurrentRegion } from '@helpers/functions';
import { getIsSubscriptionAlreadAddedToCart, getIsSubscriptionsActive, postAddSubscriptionToCart } from '@_api/smallbusinessset';

const i2iSubscriptionDetailPage = {
  subscriptionDetailParentDiv: document?.querySelector<HTMLDivElement>('.saig-o-iss-page__main'),
  miniCartNode: document?.querySelector<HTMLElement>('.saig-o-mini-cart'),
  cartCounter: document?.querySelector<HTMLDivElement>('.saig-a-button.button-cart > .saig-a-button__counter'),
  currencyNode: document?.querySelector<HTMLInputElement>('input[name=currency]'),
  selectedProductFormat: document?.querySelector<HTMLDivElement>('.saig-o-iss-page__cart-wrapper-price-details'),
  popUpIdDRMLicenseModal: '',
  isSubscriptionAddedToCartURL: '',
  isSubscriptionActiveURL: '',
  getVariantsUrl: '',
  addItemsToCartUrl: '',
  popUpIdItemExistsInCart: '',
  popUpIdItemExistsInLibrary: '',
  popUpIdItemExistsInDifferentCurrencyInCartModal: '',
  productSku: '',
  itemExistsInCartDifferentCurrency: false,
  sku: '',
  popUpIdAddToCartAPIErrorModal: '',
  loggedIn: false,
  subscribeButtonContainer: document?.querySelector<HTMLDivElement>('.saig-o-iss-page__cart-wrapper-button-container'),
  priceDetailContainer: document?.querySelector<HTMLDivElement>('.saig-o-iss-page__cart-wrapper-price-details'),

  init: function () {
    this.addEvent();
    this.getParsedAPIUrls();
  },

  getParsedAPIUrls: function () {
    const apiUrls = this.subscriptionDetailParentDiv?.dataset.attrGeneric || '';
    const parsedAPIUrls = apiUrls && JSON.parse(apiUrls?.replace(/&quot;/g, '"'));
    if (parsedAPIUrls) {
      this.popUpIdDRMLicenseModal = parsedAPIUrls?.PopUpIdDRMLicenseModal;
      this.getVariantsUrl = parsedAPIUrls?.GetVariantsUrl;
      this.addItemsToCartUrl = parsedAPIUrls?.AddItemsToCartUrl;
      this.isSubscriptionAddedToCartURL = parsedAPIUrls?.isSubscriptionAddedToCart;
      this.isSubscriptionActiveURL = parsedAPIUrls?.isSubscriptionActive;
      this.popUpIdItemExistsInCart = parsedAPIUrls?.popUpIdItemExistsInCart;
      this.popUpIdItemExistsInLibrary = parsedAPIUrls?.popUpIdItemExistsInLibrary;
      this.popUpIdItemExistsInDifferentCurrencyInCartModal = parsedAPIUrls?.PopUpIdItemExistsInDifferentCurrencyInCartModal;
      this.productSku = parsedAPIUrls?.sku;
      this.popUpIdAddToCartAPIErrorModal = parsedAPIUrls?.PopUpIdAddToCartAPIErrorModal;
    }
  },
  addEvent: function () {
    const openLicenseModal = this.subscriptionDetailParentDiv?.querySelector<HTMLButtonElement>('.open-license');
    const addToCartButton = this.subscriptionDetailParentDiv?.querySelector<HTMLButtonElement>('.add-to-cart-button');
    const loginButton = document?.querySelector<HTMLButtonElement>('.saig-o-iss-page-login-button');
    openLicenseModal?.addEventListener('click', this.openLicenseModal.bind(this));
    loginButton?.addEventListener('click', this.loginClickHandler.bind(this));
    window.addEventListener('load', () => {
      const dataAttr = this.selectedProductFormat?.dataset.attr;
      const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));
      if (parsedDataAttr) {
        this.sku = parsedDataAttr.SKU;
      }
      const isloggedin = this.subscribeButtonContainer?.dataset.loggedin;
      this.loggedIn = isloggedin?.toLowerCase() === 'true';

      addToCartButton?.addEventListener('click', this.addToCartClickHandler.bind(this));
    });
    window.addEventListener('dropdownChange', (event: any) => {
      event?.detail.inputName == 'currency' ? this.currencyChanged() : '';
    });
  },
  checkItemCanBeAdded: function () {
    let itemCanBeAdded = true;

    this.itemExistsInCartDifferentCurrency = false;
    const cartObject = document.querySelector('script[data-rct="cart-object"]');
    const jsonCartObj = cartObject?.textContent && JSON.parse(cartObject.textContent);
    jsonCartObj?.cartSummaryList.map((item: any) => {
      if (item.currencyMnemonic != this.currencyNode?.value) {
        itemCanBeAdded = false;
        this.itemExistsInCartDifferentCurrency = true;
        return;
      } else {
        if (this.sku == item.productSKU && !item.allowMultiple && !item.isMultiUserPDF && !this.loggedIn) {
          itemCanBeAdded = false;
          return;
        }
      }
    });

    return itemCanBeAdded;
  },
  loginClickHandler: function (event: any) {
    event.preventDefault();
    event.stopPropagation();
    window.redirectAfterLogin = false;
    window.dispatchEvent(new CustomEvent('openLogin'));
  },
  addItemsToCart: function (event?: any, type?: string) {
    const productObj = {
      currencyMnemonic: this.currencyNode?.value,
      licenceTerms: '',
      productFamily: 'STANDARD',
      productType: 'STANDARD',
      quantity: '1',
      sku: this.sku,
    };
    postAddProductToCart(this.addItemsToCartUrl ?? '', productObj)
      .then((response) => {
        if (response && response.flagSuccess === 1) {
          this.postAddtoCartEventToGA(this.sku);
          const cartObjectNode = document.querySelector('script[data-rct="cart-object"]');
          cartObjectNode && (cartObjectNode.textContent = JSON.stringify(response.data));

          window.dispatchEvent(new CustomEvent('getCartInfo'));
        } else {
          this.showModal(true, this.popUpIdAddToCartAPIErrorModal);
        }
      })
      .catch((error) => {
        this.showModal(true, this.popUpIdAddToCartAPIErrorModal);
        console.log('Error in API call: ' + error);
      });
  },

  isSubscriptionAlreadAddedToCart: function (event?: any) {
    const self = this;

    getIsSubscriptionAlreadAddedToCart(this.sku, this.isSubscriptionAddedToCartURL)
      .then((response: any) => {
        if (response != null) {
          if (!response) {
            return getIsSubscriptionsActive(self.sku, self.isSubscriptionActiveURL);
          } else {
            this.showModal(true, this.popUpIdItemExistsInCart, {}, {});
          }
        }
      })
      .then((response: any) => {
        if (response != null) {
          if (!response) {
            return this.addItemsToCart(event);
          } else {
            this.showModal(true, this.popUpIdItemExistsInLibrary, {}, {});
          }
        }
      })
      .then((response: any) => {
        if (response != null) {
          const cartData = response;
          if (cartData.iFlagSuccess === 1) {
            this.postAddtoCartEventToGA(this.sku);
            window.location.href = self.addItemsToCartUrl;
          }
        }
      })
      .catch((error) => {
        console.log('error calling API: ' + error);
      });
  },
  addToCartClickHandler: function (event?: any) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.loggedIn) {
      const loginWrapper = document?.querySelector<HTMLDivElement>('.saig-o-iss-page-login-wrapper');
      loginWrapper?.classList.remove('display-none');
      this.subscribeButtonContainer?.classList.add('display-none');
    } else {
      if (this.checkItemCanBeAdded()) {
        this.isSubscriptionAlreadAddedToCart(event);
        //this.addItemsToCart(event);
      } else {
        this.itemExistsInCartDifferentCurrency
          ? this.showModal(true, this.popUpIdItemExistsInDifferentCurrencyInCartModal)
          : this.showModal(true, this.popUpIdItemExistsInCart);
      }
    }
  },
  openLicenseModal: function (event?: any) {
    const self = this;
    this.showModal(true, self.popUpIdDRMLicenseModal);
  },
  currencyChanged: function () {
    const cartWrapper = this.subscriptionDetailParentDiv?.querySelector<HTMLElement>('.saig-o-iss-page__cart-wrapper-price-details-price-wrapper');

    getGetVariants(this.getVariantsUrl ?? '', this.currencyNode?.value)
      .then((response) => {
        if (response) {
          cartWrapper?.innerHTML && (cartWrapper.innerHTML = response.toString());
        }
      })
      .catch((error) => {
        console.log('Error in API call: ' + error);
      });
  },

  postAddtoCartEventToGA: function (sku: string) {
    try {
      const dataAttr = this.priceDetailContainer?.dataset.attr;
      const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));
      const priceSpan = parsedDataAttr.Price;
      const productName = parsedDataAttr.ProductName;
      var currentRegion = getCurrentRegion();
      const productObj = {
        event: 'add_to_cart',
        region: currentRegion,
        currency: this.currencyNode?.value,
        value: priceSpan ? parseFloat(priceSpan?.replace('$', '')) : 0,
        items: [
          {
            item_id: sku,
            item_name: productName,
            item_brand: parsedDataAttr.MediaType,
            item_variant: parsedDataAttr.MediaType,
            price: priceSpan ? parseFloat(priceSpan.replace('$', '')) : 0,
            quantity: 1,
          },
        ],
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(productObj);
    } catch {
      console.error('Error in add to cart event');
    }
  },

  showModal: function (show: boolean, popUpId?: string, confirmCallback?: any, closeCallback?: any) {
    window.dispatchEvent<'selectModal'>(
      new CustomEvent('selectModal', { detail: { popUpId: popUpId, confirmCallback, closeCallback, selfControl: true } })
    );
  },
};

i2iSubscriptionDetailPage.init();

export { i2iSubscriptionDetailPage };
